import { FiCalendar } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const DateTimeField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    type="datetime-local"
    placeholder={field.placeholder || field.label}
    icon={FiCalendar}
    disabled={disabled}
    required={field.is_required}
  />
);

export default DateTimeField;
